// import images
import MexicoTrek from '../assets/trek/trek2025.jpeg';
import MexicoTrek2026 from '../assets/trek/trek2026.png';
import CardinalHack from '../assets/cardinalhack/newCity.png';
import ChildrenCinema from '../assets/charity/DiaDelNino.jpeg';
import MexicoConference from '../assets/mxConf/MxConf.jpeg';
import MXSV from '../assets/mxsv/hero.png';
import { act } from 'react';

const rawUpcomingEvents = [
  {
    subtitle: 'Experiential Learning',
    title: 'Mexico Trek 2026',
    image: MexicoTrek2026,
    description:
      'Join Harvard, MIT, and Stanford students and alumni for an immersive week across Mexico. Applications open for the 2026 cohort.',
    actions: [{ text: 'Learn more', link: 'https://mxtrek.com/' }],
  },
  {
    subtitle: 'Innovation & Technology',
    title: 'CardinalHack 2025',
    image: CardinalHack,
    description:
      "LatAm x AI. A 24-hour, student-led hackathon at Stanford celebrating Latin America's builders with mentors, music, late-night tacos, and projects that drive impact back home.",
    actions: [{ text: 'Learn more', link: 'https://cardinalhack.com/' }],
  },
  {
    subtitle: 'Innovation Summit',
    title: 'Mexico in Silicon Valley 2026 (MXSV)',
    description:
      "A two-day conference at Stanford University connecting Mexico's fast-growing tech ecosystem with Silicon Valley's innovation hub. MXSV convenes founders, investors, and policymakers shaping the country's technological future.",
    actions: [{ text: 'Learn more', link: 'https://www.mxsv.org/' }],
    image: MXSV,
  },
];

export const upcomingEvents = rawUpcomingEvents.map((evt, index) => ({
  id: index + 1,
  ...evt,
}));

const rawPastEvents = [
  {
    subtitle: 'Community Impact',
    title: 'Día del Niño 2025',
    description:
      'On April 30 we partnered with Hogares El Pobrecillo de Asis (Nezahualcoyotl) and Hogares Providencia (CDMX) to host 120 kids for a private cinema screening. Every child enjoyed snacks, refreshments, and round-trip transportation thanks to the generosity of our Crimson community.',
    image: ChildrenCinema,
    mediaFolder: '/media/events/dia-del-nino-2025',
    media: [
      {
        file: 'photo-1.jpeg',
        alt: 'Crimson Club volunteers welcoming families to the Dia del Nino screening',
      },
      {
        file: 'photo-2.jpeg',
        alt: 'Children enjoying snacks before the movie begins',
      },
      {
        file: 'photo-3.jpeg',
        alt: 'Group photo with volunteers and attendees after the event',
      },
      {
        file: 'photo-4.jpeg',
        alt: 'Kids watching the 3D movie with special glasses',
      },
      {
        file: 'photo-5.jpeg',
        alt: 'Volunteers assisting children with their 3D glasses',
      },
      {
        file: 'photo-6.jpeg',
        alt: 'Happy children posing with volunteers after the screening',
      },
      {
        file: 'photo-7.jpeg',
        alt: 'Volunteers organizing snacks and refreshments for the kids',
      }

    ],
  },
  {
    subtitle: 'Social, Cultural & Politics',
    title: 'Mexico Trek 2025',
    description:
      'In collaboration with HKS student leaders, this seven-day trek brought 70 students from Stanford, MIT, and Harvard to Mexico City, Puerto Escondido, and Oaxaca. Highlights included a briefing at the Mexican Senate, a trajinera ride through Xochimilco, and a guided tour of Bellas Artes for the Emilia Hernandez performance.',
    image: MexicoTrek,
    mediaFolder: '/media/events/trek2025',
    media: [
      {
        file: 'MexicoTrekZocaloGroup.jpeg',
        alt: 'Trek participants attending a briefing at the Mexican Senate',
      },
      {
        file: 'MexicoTrekSenado.jpeg',
        alt: 'Trek participants attending a briefing at the Mexican Senate',
      },
      {
        file: 'MexicoTrekAntropologia.jpeg',
        alt: 'Trek participants visiting the National Museum of Anthropology in Mexico City',
      },
      {
        file: 'MexicoTrekLuchas.jpeg',
        alt: 'Group photo of trek participants at a lucha libre event in Mexico City',
      },
      {
        file: 'MexicoTrekPyramid.jpeg',
        alt: 'Trek participants exploring the Teotihuacan pyramids near Mexico City',
      },
      
      
      
    ],
    actions: [{ text: 'Learn more', link: 'https://www.mxsv.org/' }],
  },
  {
    subtitle: 'Policy & Public Service',
    title: 'Mexico Conference 2025',
    description:
      "Each year, HKS students host a two-day conference focused on Mexico's evolving landscape. The 2025 agenda covered business, community development, healthcare, public security, economics, and politics. Volunteers coordinated panels, managed venue logistics, and facilitated networking with Mexican policymakers, academics, and student leaders.",
    image: MexicoConference,
    actions: [{ text: 'Learn more', link: 'https://www.instagram.com/mxconference/' }],
    mediaFolder: '/media/events/mxconf2025',
    media: [
      {
        file: 'photo-1.jpg',
        alt: 'Panel discussion at the Harvard Mexico Conference 2025',
      },
      {
        file: 'photo-2.jpg',
        alt: 'Attendees networking during a break at the conference',
      },
      {
        file: 'photo-3.jpg',
        alt: 'Keynote speaker addressing the audience at the Harvard Mexico Conference 2025',
      },
      {
        file: 'photo-4.jpg',
        alt: 'Group photo of Crimson Club volunteers at the conference',
      },
    ],
  },
];

export const pastEvents = rawPastEvents.map((evt, index) => ({
  id: index + 1,
  ...evt,
}));
